import { Effect } from "../../Materials/effect";
var name = 'logDepthFragment';
var shader = "#ifdef LOGARITHMICDEPTH\ngl_FragDepthEXT=log2(vFragmentDepth)*logarithmicDepthConstant*0.5;\n#endif";
Effect.IncludesShadersStore[name] = shader;
/** @hidden */
export var logDepthFragment = { name: name, shader: shader };
//# sourceMappingURL=logDepthFragment.js.map


//////////////////
// WEBPACK FOOTER
// ./node_modules/@babylonjs/core/Shaders/ShadersInclude/logDepthFragment.js
// module id = v5yC
// module chunks = 0